import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SistemLoglariPage = () => {
  const [loglar, setLoglar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [filtre, setFiltre] = useState('hepsi');

  useEffect(() => {
    axios.get('/api/admin/loglar').then(r => setLoglar(r.data)).catch(console.error).finally(() => setYukleniyor(false));
  }, []);

  const fmt = t => t ? new Date(t).toLocaleString('tr-TR') : '-';

  const renkler = {
    giris: 'badge-tamamlandi',
    talep: 'badge-bekliyor',
    bordro: 'badge-bekliyor',
    teklif: 'badge-muhasebeci',
    hata: 'badge-hata',
  };

  const filtrelenmis = loglar.filter(l => filtre === 'hepsi' ? true : l.tip === filtre);

  return (
    <div>
      <div style={{ marginBottom: '1.5rem' }}>
        <h2 style={{ fontSize: '22px', marginBottom: '4px' }}>Sistem Logları</h2>
        <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)' }}>Sistem aktivitelerini takip edin.</p>
      </div>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid var(--border)', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {['hepsi', 'giris', 'talep', 'bordro', 'teklif', 'isealim', 'yonetim', 'hata'].map(f => (
            <button key={f} className={'btn btn-sm ' + (filtre === f ? 'btn-primary' : 'btn-secondary')} onClick={() => setFiltre(f)}>
              {f === 'hepsi' ? 'Hepsi' : f === 'giris' ? 'Giriş' : f === 'talep' ? 'Talep' : f === 'bordro' ? 'Bordro' : f === 'teklif' ? 'Teklif' : f === 'isealim' ? 'İşe Alım' : f === 'yonetim' ? 'Yönetim' : 'Hata'}
            </button>
          ))}
        </div>
        {yukleniyor ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Yükleniyor...</div>
        ) : filtrelenmis.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--yazi-ikincil)' }}>Log bulunamadı.</div>
        ) : (
          <div className="tablo-wrapper">
            <table>
              <thead><tr><th>Tarih</th><th>Ad Soyad</th><th>E-posta</th><th>İşlem</th><th>Tip</th><th>Detay</th></tr></thead>
              <tbody>
                {filtrelenmis.map(l => (
                  <tr key={l.id}>
                    <td style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>{fmt(l.tarih)}</td>
                    <td style={{ fontSize: '13px' }}>{l.kullanici_ad || '-'}</td>
                    <td style={{ fontSize: '13px' }}>{l.kullanici_email || '-'}</td>
                    <td style={{ fontSize: '13px' }}>{l.islem}</td>
                    <td><span className={'badge ' + (renkler[l.tip] || 'badge-bekliyor')}>{l.tip}</span></td>
                    <td style={{ fontSize: '12px', color: 'var(--yazi-ikincil)', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.detay || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default SistemLoglariPage;
